<div
	class="container-spinner"
	[style.position]="global ? 'fixed' : 'absolute'"
	[style.min-height]="useMinHeight ? '100px' : '0'"
>
	<mat-spinner [diameter]="diameter"></mat-spinner>
	<ng-container *ngIf="!!text && text.length > 0">
		<span class="spinner-text">{{ text }}</span>
	</ng-container>
</div>
